import { useTranslation } from 'react-i18next';
import { Input } from 'antd';
import { useSessionFormState } from '@hooks/useSessionFormState';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { SessionFormItem } from '@components/Clinicians/Session/Components/SessionFormItem';
import { type ApptActionCodes } from 'vl-common/src/schemas/getMetaAppointments';
import { useSessionAction } from '@hooks/useSessionAction';

const AdditionalInformationFormItem = ({
  onChange = () => {},
  actionCode
}: {
  onChange?: (value: string) => void;
  actionCode: ApptActionCodes;
}) => {
  const { t } = useTranslation('common');
  const {
    appointment: { appointment_completed: isCompleted, read_only: readonly }
  } = useSessionAppointment();
  const { COMMENT_KEY } = useSessionAction(actionCode);
  const [actionTaskComment, setActionTaskComment] = useSessionFormState(COMMENT_KEY);

  return (
    <SessionFormItem label={t('Additional information')} name={COMMENT_KEY} data-testid="additional-info-input">
      <Input.TextArea
        disabled={isCompleted || readonly}
        value={actionTaskComment}
        onChange={(e) => {
          setActionTaskComment(e.target.value || undefined);
          onChange(e.target.value);
        }}
        showCount
        maxLength={512}
        style={{ height: 80, resize: 'none' }}
      />
    </SessionFormItem>
  );
};

export default AdditionalInformationFormItem;
